<template>
    <div v-if="msgs" class="pb-3">
        <div class="card card-body msg-bg p-2 h-50">
            <div v-if="msgs.length > 0">
                <div v-for="msg in msgs" :key="msg.id" class="row mb-2 let-space-1" 
                    :class="{'justify-content-end': msg.sender_type == '1' || msg.sender_type == '3'}">
                    <div class="col-sm-6">
                        <div class="d-flex text-muted">
                            <div v-if="msg.sender_type == '1' || msg.sender_type == '3'">
                                Promeraia&nbsp;/&nbsp; 
                                <span v-if="msg.user_group"> {{msg.user_nm}} </span>
                                <span v-else> 自動送信 </span>
                            </div>
                            <div v-else>{{msg.user_nm}}&nbsp;/&nbsp;{{msg.user_group}}</div>
                        </div>
                        <div class="card card-body p-0 px-2 pt-2 msg" 
                             :class="{'my-msg': msg.sender_type == '1' || msg.sender_type == '3'}">
                            <div class="break-row" v-html="msg.message"></div>
                            <div class="text-right">
                                <small> {{msg.created_at | dformatm}} </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="p-3 text-center text-muted">
                メッセージはありません
            </div>
        </div>
        <div class="card card-body mt-2 p-2">
            <span class="mr-2 text-muted"><small>({{commentSize}}/2000)</small></span>
            <textarea ref="cmt" v-model.trim="comment" class="form-control" :style="commentStyle"  spellcheck=false  maxlength="2000"></textarea>
            <div class="ml-auto mt-3">
                <button class="btn btn-primary" :disabled="disableSend" @click="sendMsg">
                    <i class="fas fa-paper-plane"></i>&nbsp;送信
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            msgs: Array,
            applyId: String,
            senderType: String,
        },
        data() {
            return {
                comment: "",
                commentHeight: "80px"
            }
        },
        watch: {
            comment () {
                this.resize()
            },
        },
        computed: {
            disableSend () {
                return this.comment.length > 0 ? false : true
            },
            commentSize () {
                return this.comment.length
            },
            commentStyle () {
                return {
                    "height": this.commentHeight,
                }
            },
            ...mapGetters(['getApplyStatusDetail'])
        },
        methods: {
            resize () {
                let height = this.$refs.cmt.scrollHeight
                if (height > 60) {
                    this.commentHeight = "auto"
                    this.$nextTick(()=> {
                        this.commentHeight = this.$refs.cmt.scrollHeight + 20 + 'px'
                    })
                }
            },
            sendMsg () {
                this.$store.dispatch('addApplyHisMsg', {
                    applyId: this.applyId ,
                    senderType: this.senderType,
                    msg: this.comment
                })
                this.resetComment()
            },
            resetComment () {
                this.comment = ""
            }

        }
    }
</script>

<style lang="stylus" scoped>
    .msg-bg
        background-color: #6c757d00;
    .msg
        border-radius: 0.5rem;
        background-color: white;
    .my-msg
        border-radius: 0.5rem;
        background-color: #b0fbd0;
        border:none;
    .break-row
        white-space:pre-wrap
        word-wrap:break-word
</style>
